import { useState } from "react";
import "./Quotation.css";
import Axios from "axios";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Quotation() {
  const navigate = useNavigate();
  const [btn, setBtn] = useState(false);
  const [inCorrect, setInCorrect] = useState("");
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false); // ✅ Declare open state

  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    budget: "",
    requirement: "", // ✅ Corrected spelling
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);

    if (
      data.name &&
      data.phone &&
      data.email &&
      data.city &&
      data.budget &&
      data.requirement
    ) {
      if (isEmailAddress(data.email)) {
        setBtn(true);

        try {
          await Axios.post(process.env.REACT_APP_API_URL + "form", data)
          console.log("Data sent successfully.");
          setInCorrect("");
          setData({
            name: "",
            phone: "",
            email: "",
            city: "",
            budget: "",
            requirement: "",
          });
          setValidated(false);
          navigate("/thank-you");
        } catch (error) {
          console.error("Submission error:", error);
        } finally {
          setBtn(false);
        }
      } else {
        setInCorrect("Invalid Email");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  function isEmailAddress(str) {
    const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str);
  }

  return (
    <div id="quotation">
      <button
        className={`btn btn-quote-box ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
      >
        {open ? "CLOSE" : "Get a Quote"}
      </button>

      {open && (
        <div className={`card quote-card ${open ? "activeCard" : "closeCard"}`}>
          <h6>Get A Quote</h6>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="validationCustom01">
              <Form.Control
                required
                type="text"
                placeholder="Name*"
                name="name"
                value={data.name}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                !Name Required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="validationCustom02">
              <Form.Control
                required
                type="text"
                placeholder="Phone*"
                name="phone"
                value={data.phone}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                !Phone Number Required
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="validationCustom03">
              <Form.Control
                required
                type="email"
                placeholder="Email*"
                name="email"
                value={data.email}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                !Email Required
              </Form.Control.Feedback>
              <p style={{ color: "red", fontSize: "0.8rem" }}>{inCorrect}</p>
            </Form.Group>

            <Form.Group controlId="validationCustom04">
              <Form.Control
                required
                type="text"
                placeholder="City*"
                name="city"
                value={data.city}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                !City is required
              </Form.Control.Feedback>
            </Form.Group>

            <div className="custom-select-wrapper2 position-relative">
              <select
                required
                name="requirement" // ✅ Corrected spelling
                value={data.requirement}
                onChange={handleChange}
                className="form-select6 custom-select2"
              >
                <option value="">Select Requirement</option>
                <option value="web">Web Development</option>
                <option value="mobile">Mobile Development</option>
                <option value="app">App Development</option>
                <option value="wordpress">WordPress Development</option>
                <option value="unity">Unity Development</option>
                <option value="seo">SEO Services</option>
              </select>
            </div>

            <Form.Group controlId="validationCustom05">
              <Form.Control
                required
                type="text"
                placeholder="Budget*"
                name="budget"
                value={data.budget}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                !Budget is required
              </Form.Control.Feedback>
            </Form.Group>

            <button type="submit" disabled={btn} className="btn submit-btn">
              {btn ? "Submitted" : "Submit"}
            </button>
          </Form>
        </div>
      )}
    </div>
  );
}

export default Quotation;
